import {
  RESULT_PROBATION_FETCHING,
  RESULT_PROBATION_FAILED,
  RESULT_PROBATION_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case RESULT_PROBATION_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case RESULT_PROBATION_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case RESULT_PROBATION_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
